(function(){
    angular.module('active-add-wait-time-action.dir', [])
        .directive('activeAddWaitTimeAction', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', '$timeout', activeAddWaitTimeAction]);

    function activeAddWaitTimeAction($rootScope, $compile, $templateCache,helpers, canvasService, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function($scope){
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                // accepted values
                $scope.enums = {
                    minutes: 60,
                    hours: 24,
                    days: 365,
                    weeks: 52,
                    months: 12
                };

                //When we save a the form
                $scope.save = () => {
                    if ($scope.dataFilledCorrectly()) {
                        //Save to the global canvas object

                        $rootScope.currentJB = $rootScope.currentJB.map((i) => {
                            if(i.id === $scope.naturalId) {
                                i.data.delay = $scope.data.delay;
                                i.data.units = $scope.data.units;
                            }

                            return i;
                        });

                        const currentNode = $rootScope.currentJB.filter((i) => {
                            if(i.id === $scope.naturalId) {
                                return i;
                            }
                        });

                        const payload = {
                            JourneyName: $rootScope.currentJBTitle,
                            JourneyVersion: 1,
                            JourneyConfiguration: JSON.stringify($rootScope.currentJB),
                            JourneyTitle : $rootScope.currentJBTitle,
                            JourneyId: $rootScope.currentAPId,
                            NodeUpdated : JSON.stringify(currentNode[0])
                        };

                        canvasService
                            .updateActivatedNodes(payload)
                            .then(() => {});

                        $scope.displayList = false;
                        $scope.isElegibleForUpdate = true;
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;

                        $scope.wasSave = true;
                        $timeout(() => {
                            $scope.wasSave = false;
                        }, 1500);
                    }
                };

                // accepted values
                $scope.enums = {
                    minutes: 60,
                    hours: 24,
                    days: 365,
                    weeks: 52,
                    months: 12
                };

                $scope.parseDescription = function (delay, units) {
                    let textToParse = delay;

                    if (delay && units) {
                        let period = (delay > 1) ? 'plural' : 'singular';

                        switch(units) {
                            case "minutes":
                                units = $scope.translate(`canvas.action.addWaitTime.minutes.${period}`);
                                $scope.data.units = '';
                                break;
                            case "hours":
                                units = $scope.translate(`canvas.action.addWaitTime.hours.${period}`);
                                break;
                            case "days":
                                units = $scope.translate(`canvas.action.addWaitTime.days.${period}`);
                                break
                            case "weeks":
                                units = $scope.translate(`canvas.action.addWaitTime.weeks.${period}`);
                                break
                            case "months":
                                units = $scope.translate(`canvas.action.addWaitTime.months.${period}`);
                                break
                            default:
                                units = units;
                        }

                        textToParse = textToParse + ' ' + units.firstUpper();
                    } else {
                        textToParse = $scope.translate('commons.enterDetails');
                    }

                    return textToParse;
                };

                $scope.setUnits = (delay) => {
                    let period = (delay > 1) ? 'plural' : 'singular';

                    $scope.units = {
                        hours: $scope.translate(`canvas.action.addWaitTime.hours.${period}`),
                        days: $scope.translate(`canvas.action.addWaitTime.days.${period}`),
                        weeks: $scope.translate(`canvas.action.addWaitTime.weeks.${period}`),
                        months: $scope.translate(`canvas.action.addWaitTime.months.${period}`)
                    };
                };

                let delay = 0;
                if($scope.connections) {
                    delay = $scope.connections.data.delay;
                }
                $scope.setUnits(delay);

                // validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    let res = true;
                    $scope.errorUnits = false;
                    $scope.errorDelay = false;

                    if($scope.data.delay && $scope.data.units) {
                        if($scope.data.delay > $scope.enums[$scope.data.units]){
                            $scope.data.delay = '';
                            $scope.errorDelay = true;
                            res = false;
                        }
                    }

                    if (!$scope.data.delay) {
                        $scope.errorDelay = true;
                        res = false;
                    }

                    if (!$scope.data.units) {
                        $scope.errorUnits = true;
                        res = false;
                    }

                    return res;
                };

                //Show or hide menu on Element click
                $scope.displayList = false;
                $scope.config = function () {
                    $scope.displayList = !$scope.displayList;
                };

                //Close menu
                $scope.cancel = function() {
                    $scope.displayList = false;
                };
            }],
            link: function (scope, elem, attr) {
                if($rootScope.aElement) {
                    // bullet proving multiple targets
                    if(document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/actions/active-add-wait-time');
                    var modalTemplate = $templateCache.get('active_templates/actions/modal-active-add-wait-time');
                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.naturalId = helpers.getNaturalId(scope.id);
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function(evt, data) {
                        if(data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/actions/active-add-wait-time-action.js